import axios from "axios";
import Alert from "./Alert";

export const fileDownloader = (fileURL) => {
    let fileName = fileURL.split("/")[fileURL.split("/").length - 2];
    const token = JSON.parse(localStorage.getItem("cncToken"));

    axios.get(fileURL, {
        headers: {
            "Authorization": token ? `Bearer ${token.access}` : null
        },
        responseType: "blob"
    })
        .then(response => {
            if (response.status === 200) {
                const blob = response.data;
                if (blob.type === "text/plain") {
                    fileName += ".txt";
                }
                let downloadLink = document.createElement("a");
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = fileName;
                downloadLink.style.display = "none";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else if (response.status === 204) {
                Alert(`خطا ${response.status}!`, "فایل مورد نظر وجود ندارد!", "error");
            }
        })
        .catch(error => {
            Alert(`خطا ${error.response?.status || ""}!`, `در دانلود فایل مشکلی رخ داده است:\n${error.message}`, "error");
        });
}

export const fileDownloaderWithName = (fileURL, fileName, convertToString = false) => {
    const token = JSON.parse(localStorage.getItem("cncToken"));

    axios.get(fileURL, {
        headers: {
            "Authorization": token ? `Bearer ${token.access}` : null
        }
    })
        .then(response => {
            console.log("this is the response data", response.data);
            if (response.status === 200) {
                if (Boolean(fileName)) {
                    let blob;
                    if (convertToString) {
                        blob = new Blob([JSON.stringify(response.data)]);
                    } else {
                        blob = new Blob([response.data]);
                    }
                    let downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = fileName;
                    downloadLink.style.display = "none";
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                } else {
                    const nameOfFile = response.data.filename.split("/")[response.data.filename.split("/").length - 1];
                    let blob;
                    if (convertToString) {
                        blob = new Blob([JSON.stringify(response.data.file)]);
                    } else {
                        blob = new Blob([response.data.file]);
                    }
                    let downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = nameOfFile;
                    downloadLink.style.display = "none";
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            } else if (response.status === 204) {
                Alert(`خطا ${response.status}!`, "فایل مورد نظر وجود ندارد!", "error");
            }
        })
        .catch(error => {
            Alert(`خطا ${error.response?.status || ""}!`, `در دانلود فایل مشکلی رخ داده است:\n${error.message}`, "error");
        });
}

export const fileDownloaderWithoutFormat = (fileURL) => {
    const token = JSON.parse(localStorage.getItem("cncToken"));

    axios.get(fileURL, {
        headers: {
            "Authorization": token ? `Bearer ${token.access}` : null,
        },
        responseType: 'blob'
    })
        .then(response => {
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');

                let filename = 'downloaded_file';
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition && contentDisposition.indexOf('filename=') > -1) {
                    filename = contentDisposition.split('filename=')[1].split(';')[0].replace(/['"]/g, '');
                }

                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();

                window.URL.revokeObjectURL(url);
            } else if (response.status === 204) {
                Alert(`خطا ${response.status}!`, "فایل مورد نظر وجود ندارد!", "error");
            }
        })
        .catch(error => {
            console.error('Error downloading file:', error);
        });
};
